export const RouteLoadingFallback = () => {
  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-pk-night-2">
      <div className="w-12 h-12 rounded-full border-4 border-pk-blue-4 border-t-transparent animate-spin" />
    </div>
  );
};
